import { Id } from '@nextforce/api'
import { useRoutingContext } from 'app/routing_context'
import { useFilesWithAcknowledgementList } from 'file_folder_repository/queries/list'
import { ResourceAcknowledgementListScreenProps } from 'home/stack/types'
import { useCallback } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { ResourceAcknowledgementListView } from './views'

export function ResourceAcknowledgementListScreen({
  navigation,
  route,
}: ResourceAcknowledgementListScreenProps) {
  const { handleNavigation } = useRoutingContext()
  const { conversationId } = route.params
  const acknowledgementFilesQuery =
    useFilesWithAcknowledgementList(conversationId)

  const onPressFileAcknowledgements = useCallback(
    (fileId: Id) => {
      handleNavigation({
        routeName: 'file_acknowledgements',
        routeParams: { fileId },
      })
    },
    [handleNavigation]
  )

  return (
    <StatusBoundary
      error={acknowledgementFilesQuery.error}
      isLoading={acknowledgementFilesQuery.isLoading}
    >
      <ResourceAcknowledgementListView
        files={acknowledgementFilesQuery.data}
        onPressFileAcknowledgements={onPressFileAcknowledgements}
      />
    </StatusBoundary>
  )
}
